import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DashboardLayout from './components/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import SingleUser from './pages/SingleUser';
import Reports from './pages/Reports';
import Messages from './pages/Messages';
import Settings from './pages/Settings';
import Login from './pages/Login';
import Students from './pages/Students';
import EnterScores from './pages/EnterScores';
import StudentSingleResult from './pages/StudentSingleResult';
import EnterClassResult from './pages/EnterClassResult';
import StudentDashboard from './pages/StudentDashboard';

// Protected route component that checks Redux auth state
const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  
  // Check if user is logged in and has a valid token
  const token = localStorage.getItem('authToken');
  
  if (!isLoggedIn || !token || !user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Public route component (for login page)
const PublicRoute = ({ children }) => {
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const token = localStorage.getItem('authToken');
  
  // If user is already logged in, redirect to dashboard
  if (isLoggedIn && token && user) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route 
          path="/login" 
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } 
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<StudentDashboard />} />
          <Route path="students" element={<Students />} />
          <Route path="students/:id" element={<SingleUser />} />
          <Route path="enter-scores/:studentUuid/:classUuid" element={<EnterScores />} />
          <Route path="student-single-result" element={<StudentSingleResult />} />
          <Route path="results" element={<EnterClassResult />} />
          <Route path="classes" element={<Users />} />
          <Route path="attendance" element={<Reports />} />
          <Route path="assignments" element={<Messages />} />
          <Route path="grades" element={<Reports />} />
          <Route path="reports" element={<Reports />} />
          <Route path="messages" element={<Messages />} />
          <Route path="settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
